import React from "react";
import { HomeNavBar } from "../components/NavBar/Index";
import Cards from "../components/Home/Cards";
import styled from "styled-components";

const NormalText = styled.p`
  text-align: justify;
  font-size: 1rem;
  font-family: Helvetica;
  width: 80%;
  margin: 5vh 10% 5vh 10%;
  opacity: 0.5;
`;

const HomePage = () => {
  return (
    <>
      <HomeNavBar />
      <Cards />
      <NormalText>
        For seamless operations concerning shipment and tracking download our
        app by clicking on the download button at the navigation bar. Note,
        quotes can vary in respect to stock exchanges, therefore it is not
        stable. Want to know more about terms and conditions, or read about our
        upcoming products, you can follow our socials or sign up for newsletter
        so you don't miss any information.
      </NormalText>
    </>
  );
};

export default HomePage;
